export default __webpack_public_path__ + "820a6d02d422da8afbdfaf044aa0289b.png";